import { render, staticRenderFns } from "./NcrDashboard.vue?vue&type=template&id=2e6dbea4&"
import script from "./NcrDashboard.vue?vue&type=script&lang=js&"
export * from "./NcrDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports